import { createApiSlice } from "@common";
import {
    MY_INFO_PROFESSIONAL_DETAILS
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addEmployeeProfessionalDetails",
        method: "post",
        url: MY_INFO_PROFESSIONAL_DETAILS,
        stateKey: "message",
    },
    {
        name: "getEmployeeProfessionalDetails",
        method: "get",
        url: MY_INFO_PROFESSIONAL_DETAILS,
        stateKey: "data",
    },
    {
        name: "updateEmployeeProfessionalDetails",
        method: "put",
        url: MY_INFO_PROFESSIONAL_DETAILS,
        stateKey: "message",
    },
    {
        name: "deleteEmployeeProfessionalDetails",
        method: "delete",
        url: MY_INFO_PROFESSIONAL_DETAILS,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "EmployeeProfessionalDetails",
    apiConfig,
    customReducers,
);
const EmployeeProfessionalDetailsSlice = slice;
// Export the slice's reducer
export default EmployeeProfessionalDetailsSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addEmployeeProfessionalDetails,
    getEmployeeProfessionalDetails,
    updateEmployeeProfessionalDetails,
    deleteEmployeeProfessionalDetails
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
